console.log('33333', process.env.REACT_APP_MONTHLY_PRICE_ID);
export const prices = {
  annual: process.env.REACT_APP_YEARLY_PRICE_ID,
  monthly: process.env.REACT_APP_MONTHLY_PRICE_ID,
  default: process.env.REACT_APP_DEFAULT_PRICE_ID,
};
